export const colors: string[] = [
  '#0fbcf9',
  '#00d8d6',
  '#05c46b',
  '#ffc048',
  '#ffdd59',
];

document.body.style.background = `linear-gradient(to right, #c7efff, #ffccf6)`;
